import React from "react";

const WebPages_Databases = () => {
  return (
    <div className="tutorial-page">
      <h1>WebPages Databases</h1>
      <p>This is the WebPages Databases page content.</p>
    </div>
  );
};

export default WebPages_Databases;
